
import Vue from "vue";

const DeviceManagerAPIService = class extends Vue {
  _DEBUG = false;

  constructor() {
    super();
    if (this._DEBUG) {
      this.debugMessage('BOOTSTRAPPED DEVICE MANAGER API SERVICE');
    }
  }

  debugMessage(message) {
    if (this._DEBUG) {
      console.log(message);
    }
  }

  async fetchSignedUrl(fileName) {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/packages-url`;
    const request = new Request(url, {
        method: "POST",
        mode: "cors",
        cache: "default",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fileName,
        })
    });
    try {
        const response = await fetch(request);
        if (response.status === 403) {
          return;
        }
        if (response.status == 401) {
          return;
        }
        if (response.status == 503) {
          return this.fetchSignedUrl();
        }
        if (response.status != 200) {
            return;
        } else {
          const data = await response.json();
          return data;
        }
    } catch (dex) {
        console.error("failed to post package url", dex);
    }
  }

  async postPackageWithSignedUrl(file, url, filename = "edge_package.zip", version) {
    // Create a FormData object and append the file buffer
    const formData = new FormData();
    formData.append("file", file, { filename });
    

    return await fetch(url, {
      method: 'PUT',
      body: file
   });
  }

  async postPackage(payload) {
    if (payload && payload.signedUrl && payload.label && payload.version) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      const url = `${config.API_GATEWAY_APIGEE}/bed-manager/packages`;
      const request = new Request(url, {
          method: "POST",
          mode: "cors",
          cache: "default",
          body: JSON.stringify(payload),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
      });
      try {
          const response = await fetch(request);
          if (response.status === 403) {
            return;
          }
          if (response.status == 401) {
            return;
          }
          if (response.status == 503) {
            return this.postPackage(payload);
          }
          if (response.status != 200) {
              return;
          } else {
            const data = await response.json();
            return data;
          }
      } catch (dex) {
          console.error("failed to post package", dex);
      }
    }
  }

  async getPackages(query) {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/packages?${new URLSearchParams(query).toString()}`;
    const request = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
    });
    try {
        const response = await fetch(request);
        if (response.status === 403) {
          return;
        }
        if (response.status == 401) {
          return;
        }
        if (response.status == 503) {
          return this.getPackages();
        }
        if (response.status != 200) {
            return;
        } else {
          const data = await response.json();
          return data;
        }
    } catch (dex) {
        console.error("failed to get packages", dex);
    }
  }
  
  async postJobs(payload) {
    if (payload) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      const url = `${config.API_GATEWAY_APIGEE}/bed-manager/jobs`;
      const request = new Request(url, {
          method: "POST",
          mode: "cors",
          cache: "default",
          body: JSON.stringify(payload),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
      });
      try {
          const response = await fetch(request);
          if (response.status === 403) {
            return;
          }
          if (response.status == 401) {
            return;
          }
          if (response.status == 503) {
            return this.postJobs(payload);
          }
          if (response.status != 200) {
              return;
          } else {
            const data = await response.json();
            return data;
          }
      } catch (dex) {
          console.error("failed to post job", dex);
      }
    }
  }

  async getJobs(query) {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/jobs?${new URLSearchParams(query).toString()}`;
    const request = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
    });
    try {
        const response = await fetch(request);
        if (response.status === 403) {
          return;
        }
        if (response.status == 401) {
          return;
        }
        if (response.status == 503) {
          return this.getJobs();
        }
        if (response.status != 200) {
            return;
        } else {
          const data = await response.json();
          return data;
        }
    } catch (dex) {
        console.error("failed to get jobs", dex);
    }
  }

  async getConfiguration() {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/configuration`;
    const request = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
    });
    try {
        const response = await fetch(request);
        if (response.status === 403) {
          return;
        }
        if (response.status == 401) {
          return;
        }
        if (response.status == 503) {
          return this.getConfiguration();
        }
        if (response.status != 200) {
            return;
        } else {
          const data = await response.json();
          return data;
        }
    } catch (dex) {
        console.error("failed to get configuration", dex);
    }
  }
};

// Singleton Pattern Instantiate
if (!Vue.prototype.$DeviceManagerAPIService) {
  Vue.prototype.$DeviceManagerAPIService = new DeviceManagerAPIService();
}

export default Vue.prototype.$DeviceManagerAPIService;
